import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import styles from './HomeColheita.module.css';
import PageHeader from '../../components/PageHeader/PageHeader';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';

import { FiClipboard, FiUsers, FiPlus, FiList } from 'react-icons/fi';

const HomeColheita = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); 

  useEffect(() => {
    const MIN_LOADING_TIME = 300; 
    const startTime = Date.now();

    const loadPage = () => {
      const endTime = Date.now();
      const duration = endTime - startTime;
      const remainingTime = MIN_LOADING_TIME - duration;

      if (remainingTime > 0) {
        setTimeout(() => setLoading(false), remainingTime);
      } else {
        setLoading(false);
      }
    };

    loadPage();
  }, []);

  return (
    <div className={styles.container}>
      {loading && <LoadingOverlay text="Carregando..." />}

      {!loading && (
        <>
          <PageHeader 
            title="Gerenciamento de Produção" 
            subtitle="Módulo para controle de safras e maquinário."
            backTo="/"
          />

          <div className={styles.actionsGrid}>
            <div className={styles.actionCard} onClick={() => navigate('/cadastro-equipe-colheita')}>
                <div className={styles.iconBox}>
                    <FiPlus />
                </div>
                <h3>Nova Equipe</h3>
                <p>Cadastre uma nova equipe e vincule maquinários a ela.</p>
                <button className={styles.btnAction}>
                    <FiPlus /> Criar
                </button>
            </div>

            <div className={styles.actionCard} onClick={() => navigate('/lista-equipes')}>
                <div className={styles.iconBox}>
                    <FiList />
                </div>
                <h3>Minhas Equipes</h3>
                <p>Visualize todas as equipes cadastradas e seus veículos.</p>
                <button className={styles.btnAction}>
                    <FiUsers /> Visualizar
                </button>
            </div>
          </div>
          
          
        </>
      )}
    </div>
  );
};

export default HomeColheita;